<script setup>
import { Swiper, SwiperSlide } from "swiper/vue";
import SwiperCore, { Pagination, Mousewheel, Navigation } from "swiper";

SwiperCore.use([Pagination, Mousewheel, Navigation]);

const props = defineProps({
    blogData: {
        type: Array,
        required: true,
    },
});
</script>

<template>
    <swiper
        :slides-per-view="1"
        :rewind="true"
        :space-between="30"
        :breakpoints="{
            768: { slidesPerView: 2 },
            1024: { slidesPerView: 3 },
            1366: { slidesPerView: 4 },
        }"
        :navigation="{
            nextEl: '.slider-next',
            prevEl: '.slider-prev',
        }"
        :direction="horizontal"
        :mousewheel="true"
    >
        <swiper-slide v-for="sliderItem in blogData" :key="sliderItem.id">
            <a :href="sliderItem.url" :title="sliderItem.title">
                <div class="w-full h-80 lg:h-64 2xl:h-80 overflow-hidden rounded-xl shadow-lg z-0 mx-auto">
                    <img
                        :src="sliderItem.blog_main_image?.url"
                        :alt="sliderItem.blog_main_image?.alt"
                        class="w-full h-full object-cover"
                        loading="lazy"
                    />
                </div>
                <div
                    class="bg-white rounded-xl border border-gray-100 shadow-lg relative mx-5 py-2 px-5 -mt-7 xl:-mt-5 flex items-center justify-center min-h-[70px]"
                >
                    <h3 class="text-lg sm:text-base font-bold text-center" v-text="sliderItem.title" />
                </div>
            </a>
        </swiper-slide>
        <div class="flex justify-center mt-5">
            <div class="flex space-x-3">
                <button
                    class="slider-prev p-3 border border-gray-100 rounded-xl shadow-lg bg-white flex items-center group"
                >
                    <svg
                        aria-hidden="true"
                        data-prefix="fas"
                        data-icon="chevron-left"
                        class="svg-inline--fa fa-chevron-left fa-w-10 h-4 w-auto fill-current group-hover:text-orange"
                        xmlns="http://www.w3.org/2000/svg"
                        viewBox="0 0 320 512"
                    >
                        <path
                            fill="currentColor"
                            d="M34.52 239.03 228.87 44.69c9.37-9.37 24.57-9.37 33.94 0l22.67 22.67c9.36 9.36 9.37 24.52.04 33.9L131.49 256l154.02 154.75c9.34 9.38 9.32 24.54-.04 33.9l-22.67 22.67c-9.37 9.37-24.57 9.37-33.94 0L34.52 272.97c-9.37-9.37-9.37-24.57 0-33.94z"
                        />
                    </svg>
                </button>
                <button
                    class="slider-next p-3 border border-gray-100 rounded-xl shadow-lg bg-white flex items-center group"
                >
                    <svg
                        aria-hidden="true"
                        data-prefix="fas"
                        data-icon="chevron-right"
                        class="svg-inline--fa fa-chevron-right fa-w-10 h-4 w-auto fill-current group-hover:text-orange"
                        xmlns="http://www.w3.org/2000/svg"
                        viewBox="0 0 320 512"
                    >
                        <path
                            fill="currentColor"
                            d="M285.476 272.971 91.132 467.314c-9.373 9.373-24.569 9.373-33.941 0l-22.667-22.667c-9.357-9.357-9.375-24.522-.04-33.901L188.505 256 34.484 101.255c-9.335-9.379-9.317-24.544.04-33.901l22.667-22.667c9.373-9.373 24.569-9.373 33.941 0L285.475 239.03c9.373 9.372 9.373 24.568.001 33.941z"
                        />
                    </svg>
                </button>
            </div>
        </div>
    </swiper>
</template>
